import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=ee3ce690&scoped=true"
import script from "./BaseTag.vue?vue&type=script&lang=js"
export * from "./BaseTag.vue?vue&type=script&lang=js"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=ee3ce690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3ce690",
  null
  
)

export default component.exports